import {Group} from "@/shared/timr";
import {TreeDropdown, TreeDropdownConfig, TreeDropdownURLs} from "./treeDropdown";

export interface GroupDropdownConfig extends TreeDropdownConfig {
	allowSelectionOfNotAssigned: boolean;
	taskId?: number;
}

export class GroupDropdown extends TreeDropdown<Group, GroupDropdownConfig> {

	constructor(config: GroupDropdownConfig, urls: TreeDropdownURLs = {
		loadRootNodesURL: "reports/loadAssignedRootGroups.json",
		loadSubNodesURL: "reports/loadAssignedSubGroups.json",
		filterNodesURL: "reports/filterAssignedGroups.json"
	}) {
		super({...config, clickFolderMode: 4}, urls);
	}

	public setTaskId(taskId: number) {
		if (this.config.taskId !== taskId) {
			this.config.taskId = taskId;
			this.reset();
		}
	}

	protected isNodeSelectable(data: Group): boolean {
		return this.config.allowSelectionOfNotAssigned || data.currentUserIsLeader;
	}

	protected formatNode(data: Group): string {
		return data.name;
	}

	protected getRequestData() {
		return {
			taskId: this.config.taskId
		};
	}
}
